import Mycomplaints from "../../../jsx/components/Dashboard/MyComplaints/mycomplaints";

const MyComplaintsWrapper = () => {
  return <Mycomplaints />;
};

export const allowedRoles = [_enum.ROUTE_PERSONAS.customer];
export default constore(MyComplaintsWrapper);
